export default __webpack_public_path__ + "static/media/close-circle-filled.99b12b0e.svg";